import React, { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { Button } from '@ui-kitten/components';
import DNABox from "../../layout/DNABox/DNABox";
import DNAIcon from "../../visual/DNAIcon/DNAIcon";
const modifiers = StyleSheet.create({
    stretch: {
        flex: 1,
        alignSelf: 'stretch',
    },
    roundednone: {
        borderRadius: 0,
    },
    roundedxs: {
        borderRadius: 1,
    },
    roundedsm: {
        borderRadius: 2,
    },
    roundedmd: {
        borderRadius: 4,
    },
    roundedlg: {
        borderRadius: 10,
    },
    roundedxl: {
        borderRadius: 12,
    },
    roundedfull: {
        borderRadius: 1000,
    },
    paddingnone: {
        paddingVertical: 0,
        paddingHorizontal: 0,
        minWidth: 0,
        minHeight: 0,
        height: undefined,
    },
    paddingxs: {
        paddingVertical: 2,
        paddingHorizontal: 2,
        minWidth: 0,
        minHeight: 0,
        height: undefined,
    },
    paddingsm: {
        paddingVertical: 6,
        paddingHorizontal: 6,
        minWidth: 0,
        minHeight: 0,
        height: undefined,
    },
    paddingmd: {
        paddingVertical: 10,
        paddingHorizontal: 10,
        minWidth: 0,
        minHeight: 0,
        height: undefined,
    },
    paddinglg: {
        paddingVertical: 14,
        paddingHorizontal: 14,
        minWidth: 0,
        minHeight: 0,
        height: undefined,
    },
    paddingxl: {
        paddingVertical: 18,
        paddingHorizontal: 18,
        minWidth: 0,
        minHeight: 0,
        height: undefined,
    },
});
const getIcon = (name, customIcon, customIconName, style, rest) => (p) => {
    if (typeof name === 'string') {
        return (<DNAIcon {...p} style={[p.style, style]} name={name} testID={`icon-${name}`}/>);
    }
    // @ts-ignore [TODO] - Fix typing
    const width = style?.width || p?.style?.width;
    // @ts-ignore [TODO] - Fix typing
    const height = style?.height || p?.style?.height;
    return (<DNAIcon.Styled {...p} {...rest} style={[p.style, style]} name={customIconName} testID={'icon-' + customIconName} width={(typeof width === 'string' || typeof width === 'number') ? width : undefined} height={(typeof height === 'string' || typeof height === 'number') ? height : undefined} CustomIcon={customIcon}/>);
};
export const DNAButton = React.forwardRef(({ iconLeft, iconRight, customIconLeft, customIconRight, customIconName, accessoryLeft, accessoryRight, children, iconStyle, testID, rounded, padding, style, stretch, ...rest }, ref) => {
    const accessories = useMemo(() => ({
        accessoryLeft: iconLeft || customIconLeft
            ? getIcon(iconLeft, customIconLeft, customIconName, iconStyle, rest)
            : accessoryLeft,
        accessoryRight: iconRight || customIconRight
            ? getIcon(iconRight, customIconRight, customIconName, iconStyle, rest)
            : accessoryRight,
    }), 
    // [NOTE] - Chance of a stale value from rest, double check on functional use
    //        - Currently only on tablet nav buttons, but props are not changing atm
    [iconLeft, iconRight, customIconLeft, customIconRight, iconStyle, accessoryLeft, accessoryRight]);
    const roundedStyle = modifiers[`rounded${rounded}`];
    const paddingStyle = modifiers[`padding${padding}`];
    const stretchStyle = stretch ? modifiers.stretch : undefined;
    return (<DNABox ref={ref} testID={testID} style={stretchStyle}>
      <Button {...accessories} {...rest} style={[
            style,
            roundedStyle,
            paddingStyle,
            stretchStyle,
        ]}>
        {children}
      </Button>
    </DNABox>);
});
export default DNAButton;
//# sourceMappingURL=DNAButton.js.map